export default {
  pink: {
    backgroundColor: '#FF8FB2',
  },
  violet: {
    backgroundColor: '#AA3191',
  },
  portage: {
    backgroundColor: '#94B0EA',
  },
  denim: {
    backgroundColor: '#1B60DB',
  },
  wisteria: {
    backgroundColor: '#D285D6',
  },
  purple: {
    backgroundColor: '#6552A8',
  },
  allports: {
    backgroundColor: '#027E9B',
  },
  turquoise: {
    backgroundColor: '#25D7F4',
  },
}
